import {createSlice} from '@reduxjs/toolkit';
import {baseSetValue} from "../../utils";

export interface PlaylistSliceState {
    isLoading: boolean;
    error?: string;
}

const initialState: PlaylistSliceState = {
    isLoading: false,
};

const playlistSlice = createSlice({
    name: 'playlist',
    initialState,
    reducers: {
        setValue: baseSetValue<PlaylistSliceState>()
    },
});

export const {setValue} = playlistSlice.actions;
export default playlistSlice.reducer;
